// TrustStrip.jsx
// Four horizontal credibility signals that kill "is this just guesswork?"
import React from "react";

export default function TrustStrip({ items = [] }) {
  if (!items?.length) return null;

  return (
    <div className="sx-container">
      <div className="sx-trust-strip">
        {items.map((item, i) => (
          <div key={i} className="sx-trust-item">
            <span className="sx-trust-icon">{item.icon}</span>
            <div>
              <div className="sx-trust-label">{item.label}</div>
              {item.sub && <div className="sx-trust-sub">{item.sub}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
